<template>

	<v-dialog v-model="dialog" :max-width="options.width" :style="{ zIndex: options.zIndex }" @keydown.esc="cancel" persistent>
		<v-card>
		
			<v-form ref="form" @submit.prevent="agree">
				<v-text-field
					class="px-3 pt-3"
					:label="title"
					v-model="someString"
					:rules="agile.fieldRules.nameRules"
					outlined
					dense
					autofocus
					validate-on-blur
				></v-text-field>
			</v-form>

			<v-card-actions class="pt-0">
				<v-spacer></v-spacer>
				<v-btn color="primary darken-1" text @click.native="agree">Create</v-btn>
				<v-btn color="primary darken-1" text @click.native="cancel">Cancel</v-btn>
			</v-card-actions>

		</v-card>
	</v-dialog>

</template>



<script>

// ----------------------------------------------------
//
//  Main script
//
// ----------------------------------------------------

import agile from "@/shift/agile";


export default
{
	data: () =>
	({
		dialog: false,
		resolve: null,
		reject: null,
		someString: null,
		title: null,
		options:
		{
			color: 'primary',
			width: 320,
			zIndex: 200
		}
	}),

	computed:
	{
		agile()
		{
			return agile;
		},
	},

	

	methods:
	{
		// ----------------------------------
        //	Form validation
        // ----------------------------------
        
		open(title, options)
		{
			this.dialog = true;
			this.title = title;
			
			if (this.$refs.form)
			{
				this.$refs.form.reset();
			}
			
			this.someString = '';
			this.options = Object.assign(this.options, options);

			if (!options) this.options.color = 'primary';
			if (options && !options.color) this.options.color = 'primary';

			return new Promise((resolve, reject) =>
			{
				this.resolve = resolve;
				this.reject = reject;
			})
		},

		agree()
		{
			if (this.$refs.form.validate())
			{
				this.resolve(this.someString);
				this.dialog = false;
			}
		},

		cancel()
		{
			this.resolve(false);
			this.dialog = false;
		}
	}
}
</script>